export default {
  title: 'Loja online',
  fields: {
    has_reservations: {
      label: 'Mostrar reservas na loja online',
    },
  },
  button: {
    save: 'Guardar',
    preview: 'Pré-visualizar',
  },
  no_storefront: {
    title: 'Nenhuma loja online encontrada',
    description: 'Por favor, crie uma loja online.',
    button: {
      storefront: 'Ir para a loja online',
    },
  },
  response_messages: {
    success: 'Atualizado com sucesso.',
    failed: 'Atualização falhou.',
  },
};
